"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyNotAvailableException = void 0;
class PropertyNotAvailableException extends Error {
}
exports.PropertyNotAvailableException = PropertyNotAvailableException;
//# sourceMappingURL=property-not-available-exception.js.map